import { DSelect } from "@/components/common/DeskSelect";

/** iter448 pt 1 — gabarits communs du Tableau de bord Trésorerie (1.3 → 1.6). */
export const C = { teal: "#1D9E75", blue: "#3B9EFF", red: "#E24B4A", gold: "#D9A021", violet: "#6B5BD6", indigo: "#3B6FD6", amber: "#F59E0B", grey: "#8A8A93", soft: "#F87171" };
export const MONTHS = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];
export const mLabel = (ym) => `${MONTHS[Number(ym.slice(5, 7)) - 1]} ${ym.slice(2, 4)}`;
export const MONO = { fontFamily: "'JetBrains Mono', ui-monospace, monospace" };
export const CARD = { background: "#17171B", border: "1px solid #26262C", borderRadius: 10 };
export const SEL = { background: "#141418", border: "1px solid #33333B", borderRadius: 6, fontSize: 10, color: "#D6D6DC", height: 22, padding: "0 7px", minWidth: 0 };

/** Sélecteur propre à une carte (1.5) : menu déroulant Desk 10 px. */
export function Sel({ value, onChange, options, testId }) {
  return <DSelect value={value} onChange={(e) => onChange(e.target.value)} style={SEL} width={180} data-testid={testId}>{options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</DSelect>;
}

export const Empty = ({ testId }) => <div style={{ fontSize: 11, color: "#6B6B73", padding: "14px 0", textAlign: "center" }} data-testid={testId}>Aucune donnée sur cette période</div>;

/** Carte 1.5 : bande gauche 28 px pleine couleur + icône blanche 13 px, titre 9 px gras majuscules, sélecteur à droite, clic titre = écran détaillé. */
export function DashCard({ title, icon: Icon, color, right, onTitle, children, testId, style }) {
  return (
    <section className="flex" style={{ ...CARD, height: "100%", overflow: "hidden", minWidth: 0, ...style }} data-testid={testId}>
      <div className="flex items-start justify-center shrink-0" style={{ width: 28, background: color, paddingTop: 10 }}><Icon size={13} color="#fff" /></div>
      <div className="flex flex-col min-w-0" style={{ flex: 1, padding: "8px 10px 9px" }}>
        <div className="flex items-center" style={{ gap: 6, marginBottom: 7, minHeight: 22 }}>
          <button type="button" onClick={onTitle} className="truncate hover:underline" style={{ fontSize: 9, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".1em", color: "#E8E8EC", textAlign: "left", background: "none", padding: 0 }} data-testid={`${testId}-title`}>{title}</button>
          <span style={{ flex: 1 }} />
          {right}
        </div>
        <div className="flex flex-col min-w-0" style={{ flex: 1, minHeight: 0 }}>{children}</div>
      </div>
    </section>
  );
}

/** Pied de carte : séparateur + total. */
export const Foot = ({ label, value, link, testId }) => (
  <div className="flex items-center" style={{ gap: 8, marginTop: "auto", paddingTop: 6, borderTop: "1px solid #222228", fontSize: 10, color: "#C8C8CC" }} data-testid={testId}>
    <span className="truncate">{label}</span><span style={{ flex: 1 }} />{value && <b className="tabular-nums" style={{ color: "#F0F0F4" }}>{value}</b>}{link}
  </div>
);

export const Legend = ({ items }) => <div className="flex flex-wrap" style={{ gap: "3px 10px", fontSize: 9.5, color: "#A9A9B2", marginTop: 5 }}>{items.map(([col, l]) => <span key={l} className="inline-flex items-center" style={{ gap: 4 }}><span style={{ width: 7, height: 7, borderRadius: 2, background: col }} />{l}</span>)}</div>;
